import { createSlice } from "@reduxjs/toolkit";

export const projectsSlice = createSlice({
  name: "projects",
  initialState: {
    items: [],
    projectTalents: {},
  },
  reducers: {
    setProjects: (state, { payload }) => {
      state.items = payload;
    },
    addProject: (state, { payload }) => {
      state.items = [payload, ...state.items];
    },
    addProjectTalent: (state, { payload }) => {
      state.projectTalents = {
        ...state.projectTalents,
        [payload.talentUserId]: [
          ...(state.projectTalents[payload.talentUserId] || []),
          payload,
        ],
      };
    },
    addProjectTalents: (state, { payload }) => {
      payload.reduce((acc, pt) => {
        acc[pt.talentUserId] = [...(acc[pt.talentUserId] || []), pt];
        return acc;
      }, state.projectTalents);
    },

    rejectProjectTalent: (state, { payload }) => {
      state.projectTalents = {
        ...state.projectTalents,
        [payload.talentUserId]: state.projectTalents[payload.talentUserId].map(
          (pt) =>
            pt.projectId === payload.projectId
              ? { ...pt, rejectedAt: new Date().toString() }
              : pt
        ),
      };
    },
    removeProjectTalent: (state, { payload }) => {
      state.projectTalents = {
        ...state.projectTalents,
        [payload.talentUserId]: state.projectTalents[
          payload.talentUserId
        ].filter((pt) => pt.projectId !== payload.projectId),
      };
    },
  },
});

// SELECTORS

export const selectProjects = (state) => state.projects.items;
export const selectProjectTalents = (state) => state.projects.projectTalents;

// ACTIONS

export const {
  setProjects,
  addProject,
  addProjectTalent,
  addProjectTalents,
  removeProjectTalent,
  rejectProjectTalent,
} = projectsSlice.actions;

export default projectsSlice.reducer;
